module.exports = __webpack_public_path__ + "img/logo.84ac6d1a.png";